// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__QFKiX","colCheckbox":"styles_colCheckbox__1cOoq"};